export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.5.5-1246.34",
  commitId: "1b95b102e2be973552e22f11c06d04d0dfc6595f",
  commitTime: "2026-05-05T12:46:34.000Z",
});
